<template>
  <Notifications
    class="notify"
    group="notify"
  >
    <template v-slot:body="props">
      <div
        class="notify-wrapper"
        :class="[`notify_${props.item.type}`]"
      >
        <div class="notify-content">
          {{ props.item.text }}
        </div>
      </div>
    </template>
  </Notifications>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted } from 'vue';
import { notify, type NotificationsOptions } from '@kyvg/vue3-notification';
import eventBus from '@/setup/eventBus';

onMounted(() => {
  eventBus.$on('notify-event', sendNotify);
});

onBeforeUnmount(() => {
  eventBus.$off('notify-event', sendNotify);
});

const sendNotify = (data: Pick<NotificationsOptions, 'type' | 'text'>) => {
  notify({
    group: 'notify',
    type: data.type,
    duration: 1500,
    // pauseOnHover: true,
    ignoreDuplicates: true,
    text: data.text,
  });
};
</script>

<style lang="scss">
.notify {
  margin-top: 20px;
  margin-right: 20px;
  z-index: 9001 !important;
  &-wrapper {
    padding: 12px;
    border-radius: 8px;
    border: none;
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }
  &-content {
    font-size: 14px;
    font-weight: 500;
    color: var(--text-body-invert);
  }
  &_success {
    background-color: var(--notifications-positive);
  }
  &_error {
    background-color: var(--notifications-negative);
  }
  &_warn {
    background-color: var(--notifications-warning);
  }
  &_info {
    background-color: var(--notifications-info);
  }
}
</style>
